import React, { useState, useEffect } from "react"
import { FaHeart, FaRegHeart } from "react-icons/fa"
import articleApi from "../api/articleApi"
import { useUser } from "../helpers/userContext"
import { useModal } from "../helpers/modalContext"

const LikeButton = ({ articleId, initialLikeStatus, likesCount }) => {
  // Handle undefined initial state gracefully
  const [liked, setLiked] = useState(initialLikeStatus === true)
  const [likesCountState, setLikesCountState] = useState(Number(likesCount) || 0)
  const [loading, setLoading] = useState(false)
  const [showTooltip, setShowTooltip] = useState(false)
  const { token } = useUser()
  const { openModal } = useModal()
  
  // Show loading state if initialLikeStatus is undefined (still fetching)
  const isInitializing = initialLikeStatus === undefined && token

  useEffect(() => {
    // Only update if we have a definite value (not undefined)
    if (initialLikeStatus !== undefined) {
      setLiked(initialLikeStatus === true)
    }
    setLikesCountState(Number(likesCount) || 0)
  }, [initialLikeStatus, likesCount])

  const handleLikeClick = async event => {
    event.preventDefault()
    event.stopPropagation()
    
    // Hide tooltip immediately when clicked
    setShowTooltip(false)
    setLoading(true)

    if (!token) {
      openModal("login")
      setLoading(false)
      return
    }

    try {
      const response = liked
        ? await articleApi.unlikeArticle(articleId)
        : await articleApi.likeArticle(articleId)

      if (
        response.data &&
        "liked" in response.data &&
        "likesCount" in response.data
      ) {
        setLiked(response.data.liked)
        setLikesCountState(response.data.likesCount) // Directly set from server response
      } else {
        // If server doesn't return likesCount, fallback to optimistic UI update
        setLiked(!liked)
        setLikesCountState(prevCount => (liked ? prevCount - 1 : prevCount + 1))
        console.warn(
          "Server response did not include updated likesCount. Using optimistic update."
        )
      }
    } catch (error) {
      if (error.response) {
        console.log("Error Response:", error.response.data)
      }
      // Revert the optimistic update if the request fails
      setLiked(prevLiked => !prevLiked)
      setLikesCountState(prevCount => (liked ? prevCount + 1 : prevCount - 1))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="relative flex items-center">
  

      <div className="relative">
        <button
          onClick={handleLikeClick}
          className={`p-2 rounded-full flex items-center justify-center transition-all duration-300 ${
            loading || isInitializing ? "animate-pulse" : ""
          }`}
          disabled={loading || isInitializing}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          {loading ? (
            <FaHeart
              className={`text-2xl ${liked ? "text-red-500" : "text-gray-300"}`}
            />
          ) : (
            <>
              {liked ? (
                <FaHeart className="text-2xl text-red-500" />
              ) : (
                <FaRegHeart className="text-2xl text-gray-300" />
              )}
            </>
          )}
        </button>
        
        {/* Simple Tooltip */}
        {showTooltip && (
          liked ? (
            <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1
                          bg-gray-800 text-white text-xs font-medium
                          px-2 py-1 rounded shadow-md
                          z-10 whitespace-nowrap">
              Hiqe
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 
                            border-solid border-t-gray-800 border-t-4 border-x-transparent border-x-4 border-b-0"></div>
            </div>
          ) : (
            <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1
                          bg-gray-800 text-white text-xs font-medium
                          px-2 py-1 rounded shadow-md
                          z-10 whitespace-nowrap">
              Ruaje
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 
                            border-solid border-t-gray-800 border-t-4 border-x-transparent border-x-4 border-b-0"></div>
            </div>
          )
        )}
      </div>
    </div>
  )
}

export default LikeButton
